import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function BrandHeading({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <h2 className={cn("font-display text-xl font-black uppercase tracking-wide", className)}>
      <span className="bb-marker-open" aria-hidden />
      {children}
      <span className="bb-marker-close" aria-hidden />
    </h2>
  );
}

export function BrandDivider({ className }: { className?: string }) {
  return <hr className={cn("bb-divider my-4", className)} />;
}
